import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../api";
import { useAuth } from "../AuthContext";
import { Copy, Trophy, Share2 } from "lucide-react";
import { RankingAdmin } from "../components/RankingAdmin";

export default function ReferralsPage() {
  const { user } = useAuth();
  const [board, setBoard] = useState([]);
  const loadBoard = () => api.get("/referrals/leaderboard").then(r=> setBoard(r.data));
  useEffect(() => { loadBoard(); }, []);
  const isAdmin = ["admin", "admin_admin"].includes(user?.role);

  const copyLink = () => {
    if (!user) { toast.error("Faça login para gerar seu link"); return; }
    const link = `${window.location.origin}/cadastro?ref=${user.referral_code}`;
    navigator.clipboard.writeText(link);
    toast.success("Link copiado!");
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-14">
      <div className="text-center mb-10">
        <div className="tag-sun mb-3 inline-block">INDIQUE & GANHE</div>
        <h1 className="font-serif text-4xl sm:text-5xl">Ranking das embaixadoras</h1>
        <p className="text-[color:var(--ink-500)] mt-3">Convide amigas, some pontos e conquiste recompensas exclusivas todo mês.</p>
      </div>

      {isAdmin && <RankingAdmin onReset={loadBoard}/>}

      {user && (
        <div className="card-arya p-6 mb-8 flex flex-col sm:flex-row items-center gap-4 justify-between">
          <div>
            <p className="text-xs tracking-widest font-display text-[color:var(--sun-700)]">SEU CÓDIGO</p>
            <p className="font-mono text-2xl tracking-widest text-[color:var(--sun-700)]">{user.referral_code}</p>
          </div>
          <div className="flex gap-2">
            <button onClick={copyLink} className="btn-ghost inline-flex items-center gap-2" data-testid="btn-copy-link"><Share2 size={14}/> Copiar link</button>
            <button onClick={() => { navigator.clipboard.writeText(user.referral_code); toast.success("Código copiado!"); }} className="btn-gold inline-flex items-center gap-2" data-testid="btn-copy-code"><Copy size={14}/> Copiar código</button>
          </div>
        </div>
      )}

      <div className="card-arya p-6">
        <div className="flex items-center gap-2 mb-5"><Trophy size={16} className="text-[color:var(--sun-600)]"/><h2 className="font-serif text-2xl">Top embaixadoras</h2></div>
        {board.length === 0 && <p className="text-sm text-[color:var(--ink-500)]">Ainda não há indicações registradas.</p>}
        <ol className="divide-y divide-[var(--line)]">
          {board.map((c, i) => (
            <li key={c.referral_code} className="py-4 flex items-center gap-4" data-testid={`rank-${i+1}`}>
              <span className={`w-8 h-8 rounded-full grid place-items-center font-serif text-lg ${i<3 ? 'bg-[color:var(--sun-500)] text-white' : 'bg-[var(--cream-100)] text-[color:var(--ink-700)]'}`}>{i+1}</span>
              <div className="flex-1">
                <p className="font-display font-semibold">{c.name}</p>
                <p className="text-xs text-[color:var(--ink-500)]">{c.referral_code}</p>
              </div>
              <span className="font-serif text-xl text-[color:var(--sun-700)]">{c.referral_points || 0} pts</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
